import ReactDOM from 'react-dom';
import { __ } from '@wordpress/i18n';
import { applyFilters } from '@wordpress/hooks';
import { useNavigate } from 'react-router-dom';

const UpgradePopup = ({ closeState, goToLicensePage }) => {

    return ReactDOM.createPortal(
        <div className="jkit-upgrade-popup-overlay" onClick={() => closeState(false)}>
            <div className="jkit-upgrade-popup">
                <button className="upgrade-popup-close" onClick={() => closeState(false)}>
                    <CloseButton />
                </button>
                <UpgradePro goToLicensePage={goToLicensePage} />
            </div>
        </div>,
        document.body
    );
};

const CloseButton = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.70646 5.8119L9.89389 10L10.707 9.1881L6.51845 5L10.707 0.813046L9.89504 0L5.70646 4.1881L1.51902 0L0.707031 0.813046L4.89447 5L0.707031 9.18695L1.51902 10L5.70646 5.8119Z" fill="white" fill-opacity="0.7" />
    </svg>
}

const UpgradePro = ({ goToLicensePage }) => {
    const { imgDir, proActive, homeSlug: root } = window['JkitDashboardOption'];
    const navigate = useNavigate();

    const handleClick = () => {
        if (proActive) {
            goToLicensePage();
        } else {
            navigate(`?page=${root}&utm_source=jeg-elementor-kit&utm_medium=dashboard`);
        }
    };


    return <div className="upgrade-pro-wrapper">
        <div className="upgrade-pro-content">
            <img className="banner background" src={imgDir + '/admin/pro-banner-gradient-bg.png'} />
            <img className="banner pattern" src={imgDir + '/admin/pro-banner-pattern-bg.png'} />
            <img className="banner center" src={imgDir + '/admin/pro-banner-images.png'} />
            <img className="banner arrow" src={imgDir + '/admin/pro-banner-arrow.png'} />
            {applyFilters('jkit.dashboard.upgrade.text', <h3 className="content-title">
                {__('Upgrade ', 'jkit')}
                <span className="gradient-text">{__('JEG KIT PRO', 'jkit')}</span>
                {__(' version to unlock these premium blocks ', 'jkit')}
            </h3>)}
            <div className="upgrade-pro-button" onClick={() => handleClick()}>
                <div className="button-content-wrapper">
                    {proActive && <>
                        <span>{applyFilters('jkit.dashboard.upgrade.button', __('Activate License', 'jkit'))}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path d="M3.81936 13.1102C3.1728 13.1101 2.53813 12.9307 1.98154 12.5907C1.42495 12.2508 0.96685 11.7627 0.655019 11.1775C0.343189 10.5922 0.189056 9.93123 0.2087 9.26346C0.228343 8.59569 0.421044 7.9456 0.7667 7.38101C1.11236 6.81642 1.5983 6.35801 2.17384 6.05361C2.74938 5.74921 3.39343 5.60996 4.0388 5.6504C4.68418 5.69084 5.30722 5.90948 5.84295 6.28352C6.37867 6.65755 6.80745 7.17328 7.08454 7.77689H14.6586L16.207 9.37689L14.6586 10.9769L13.6263 9.91022L12.594 10.9769L11.5617 9.91022L10.5293 10.9769L9.49704 9.91022L8.46474 10.9769H7.08454C6.79146 11.6153 6.32905 12.1547 5.75106 12.5323C5.17306 12.91 4.50321 13.1104 3.81936 13.1102ZM2.78705 10.4436C3.06084 10.4436 3.32341 10.3312 3.517 10.1311C3.7106 9.9311 3.81936 9.65979 3.81936 9.37689C3.81936 9.09399 3.7106 8.82268 3.517 8.62264C3.32341 8.4226 3.06084 8.31022 2.78705 8.31022C2.51327 8.31022 2.2507 8.4226 2.0571 8.62264C1.86351 8.82268 1.75475 9.09399 1.75475 9.37689C1.75475 9.65979 1.86351 9.9311 2.0571 10.1311C2.2507 10.3312 2.51327 10.4436 2.78705 10.4436Z" fill="white" />
                        </svg>
                    </>}
                    {!proActive && <>
                        <span>{__('Upgrade To PRO', 'jkit')}</span>
                        <svg width={16} height={16} viewBox="0 0 15 15" fill={'white'} transform={'translate(0,0)'} xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.25 9.5L2 2.625L5.4375 5.75L7.625 2L9.8125 5.75L13.25 2.625L12 9.5H3.25ZM12 11.375C12 11.75 11.75 12 11.375 12H3.875C3.5 12 3.25 11.75 3.25 11.375V10.75H12V11.375Z" fill={'white'} />
                        </svg>
                    </>}

                </div>
            </div>
        </div>
    </div>;
};

export const UpgradeProDashboard = ({ goToLicensePage, withArrow = true }) => {
    const { imgDir, proActive, homeSlug: root } = window['JkitDashboardOption'];
    const navigate = useNavigate();

    const handleClick = () => {
        if (proActive) {
            goToLicensePage();
        } else {
            navigate(`?page=${root}&utm_source=jeg-elementor-kit&utm_medium=dashboard`);
        }
    };


    return <div className="upgrade-pro-wrapper dashboard">
        <div className="upgrade-pro-content">
            <img className="banner background" src={imgDir + '/admin/pro-banner-gradient-bg.png'} />
            <img className="banner pattern" src={imgDir + '/admin/pro-banner-pattern-bg.png'} />
            <img className="banner center" src={imgDir + '/admin/pro-banner-images.png'} />
            {withArrow && <img className="banner arrow" src={imgDir + '/admin/pro-banner-arrow.png'} />}
            {applyFilters('jkit.dashboard.upgrade.text', <h3 className="content-title">
                {__('Unlock More With ', 'jkit')}
                <span className="gradient-text">{__('JEG KIT PRO', 'jkit')}</span>
            </h3>)}
            <p>Elevate your website with our all-in-one widget collection.</p>
            <div className="upgrade-pro-button" onClick={() => handleClick()}>
                <div className="button-content-wrapper">
                    {proActive && <>
                        <span>{applyFilters('jkit.dashboard.upgrade.button', __('Activate License', 'jkit'))}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path d="M3.81936 13.1102C3.1728 13.1101 2.53813 12.9307 1.98154 12.5907C1.42495 12.2508 0.96685 11.7627 0.655019 11.1775C0.343189 10.5922 0.189056 9.93123 0.2087 9.26346C0.228343 8.59569 0.421044 7.9456 0.7667 7.38101C1.11236 6.81642 1.5983 6.35801 2.17384 6.05361C2.74938 5.74921 3.39343 5.60996 4.0388 5.6504C4.68418 5.69084 5.30722 5.90948 5.84295 6.28352C6.37867 6.65755 6.80745 7.17328 7.08454 7.77689H14.6586L16.207 9.37689L14.6586 10.9769L13.6263 9.91022L12.594 10.9769L11.5617 9.91022L10.5293 10.9769L9.49704 9.91022L8.46474 10.9769H7.08454C6.79146 11.6153 6.32905 12.1547 5.75106 12.5323C5.17306 12.91 4.50321 13.1104 3.81936 13.1102ZM2.78705 10.4436C3.06084 10.4436 3.32341 10.3312 3.517 10.1311C3.7106 9.9311 3.81936 9.65979 3.81936 9.37689C3.81936 9.09399 3.7106 8.82268 3.517 8.62264C3.32341 8.4226 3.06084 8.31022 2.78705 8.31022C2.51327 8.31022 2.2507 8.4226 2.0571 8.62264C1.86351 8.82268 1.75475 9.09399 1.75475 9.37689C1.75475 9.65979 1.86351 9.9311 2.0571 10.1311C2.2507 10.3312 2.51327 10.4436 2.78705 10.4436Z" fill="white" />
                        </svg>
                    </>}
                    {!proActive && <>
                        <span>{__('Upgrade To PRO', 'jkit')}</span>
                        <svg width={16} height={16} viewBox="0 0 15 15" fill={'white'} transform={'translate(0,0)'} xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.25 9.5L2 2.625L5.4375 5.75L7.625 2L9.8125 5.75L13.25 2.625L12 9.5H3.25ZM12 11.375C12 11.75 11.75 12 11.375 12H3.875C3.5 12 3.25 11.75 3.25 11.375V10.75H12V11.375Z" fill={'white'} />
                        </svg>
                    </>}

                </div>
            </div>
        </div>
    </div>;
};

export default UpgradePopup;
